import Datalist from './datalist';
import DatalistComponent from './components/list';

const inputEls = document.queryAll('.slx-nearby__input');

inputEls.forEach(initInput);

function initInput(el) {
	let dList = new Datalist({
		el,
		component: DatalistComponent
	});
	dList.start();
}
